<p-toast></p-toast>

<div class="pi-page">
  <div class="pi-header">
    <h1 class="pi-title">Integrations</h1>
    <div class="switch-tabs">
      <button [class.active]="activeIntegration === 'kisha'" (click)="setIntegration('kisha')">Kisha</button>
      <button [class.active]="activeIntegration === 'ewmr'" (click)="setIntegration('ewmr')">EWMR</button>
      <button [class.active]="activeIntegration === 'commonTags'" (click)="setIntegration('commonTags')">Common Tags</button>
      <button [class.active]="activeIntegration === 'dashboard'" (click)="setIntegration('dashboard')">Dashboard</button>
    </div>
  </div>

  <div class="pi-panel">
    <div class="pi-panel-hdr">
      <p class="pi-panel-desc">Select or deselect integration mappings for the selected project template.</p>
      <div class="pi-actions">
        @if (activeIntegration === 'dashboard') {
          <select
            class="pi-select pi-select--category"
            [(ngModel)]="dashboardTemplateCategory"
            (ngModelChange)="onDashboardTemplateCategoryChange()"
            [disabled]="loadingTemplates">
            @for (option of dashboardTemplateCategoryOptions; track option.value) {
              <option [ngValue]="option.value">{{ option.label }}</option>
            }
          </select>
        }

        <select
          class="pi-select"
          [(ngModel)]="selectedProjectTemplateId"
          (ngModelChange)="onTemplateChange()"
          [disabled]="loadingTemplates || projectTemplates.length === 0">
          <option [ngValue]="null" disabled>Select Template</option>
          @for (template of projectTemplates; track template.templateId) {
            <option [ngValue]="template.templateId">{{ template.templateName }}</option>
          }
        </select>
        <button class="pi-btn-save" type="button" (click)="save()" [disabled]="saving || loadingAssociations || loadingMappings">
          <i class="ri-save-line"></i>
          Save
        </button>
      </div>
    </div>

    <div class="pi-table-wrap">
      <div class="pi-data-table">
        <div class="pi-row pi-row--header">
          <div class="pi-cell pi-cell--check">
            <div class="pi-checkbox-wrap">
              <input class="pi-checkbox" type="checkbox" [(ngModel)]="allSelected" (change)="toggleSelectAll()" />
            </div>
          </div>
          @if (showSourceColumn) {
            <div class="pi-cell pi-cell--source">{{ sourceLabel }}</div>
          }
          <div class="pi-cell pi-cell--kansei">{{ idLabel }}</div>
          <div class="pi-cell pi-cell--dtype">Data Type</div>
          <div class="pi-cell pi-cell--comments">Comments</div>
        </div>

        @if (rows.length === 0 && !loadingMappings) {
          <div class="pi-empty">No integration rows found.</div>
        }

        @for (row of rows; track row.integrationMappingId) {
          <div class="pi-row">
            <div class="pi-cell pi-cell--check">
              <div class="pi-checkbox-wrap">
                <input class="pi-checkbox" type="checkbox" [(ngModel)]="row.selected" (change)="onRowSelectionChange()" />
              </div>
            </div>
            @if (showSourceColumn) {
              <div class="pi-cell pi-cell--source">{{ row.sourceId }}</div>
            }
            <div class="pi-cell pi-cell--kansei">{{ row.kanseiId }}</div>
            <div class="pi-cell pi-cell--dtype">{{ row.dataType }}</div>
            <div class="pi-cell pi-cell--comments">{{ row.comments }}</div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
